import styled from 'styled-components';

import {Select, Stack, Switch} from "@chakra-ui/react";
import {useStoreProfile} from "../../../store";
import FormContainer from "../../../components/form_container";
import {WhiteMain} from "../../../components/main";
import {FixedTopBar} from "../../../components/top_bar";
import {themecolors} from "../../../utils/themecolors";
import {useActions} from "../../../app_context";

const SwitchHeading = styled.div``;
const SwitchDescription = styled.div``;
const SwitchContainer = styled.div``
const SwitchText = styled.div``;
const SwitchItem = styled.div``;

const GeneralSettings = styled(({className}) => {

    const actions = useActions();
    const settings = useStoreProfile();
    const apply = async (changes) => {
        await actions.settingsChanged(changes);
    };

    return (
        <>
            <FixedTopBar back title="General" border={false}/>
            <WhiteMain className={className}>
                <FormContainer>

                    <Stack mb={"20px"}>
                        <SwitchHeading>Post View</SwitchHeading>
                        <Select value={settings.expand}
                                onChange={(e) => apply({expand: e.currentTarget.value})}>
                            <option value="condensed">Condensed</option>
                            <option value="card">Card</option>
                        </Select>
                    </Stack>

                    <Stack mb={"20px"}>
                        <SwitchHeading>Comment Sort</SwitchHeading>
                        <Select value={settings.comment_sort}
                                onChange={(e) => apply({comment_sort: e.currentTarget.value})}>
                            <option value="top">Top</option>
                            <option value="new">New</option>
                            <option value="old">Old</option>
                            <option value="controversial">Controversial</option>
                        </Select>
                    </Stack>

                    <SwitchContainer>
                        <SwitchText>
                            <SwitchHeading>Hide Upvoted Posts</SwitchHeading>
                            <SwitchDescription>
                                Posts will be hidden from feeds after upvoting.
                            </SwitchDescription>
                        </SwitchText>
                        <SwitchItem>
                            <Switch isChecked={settings.hide_upvoted}
                                    onChange={(value) => apply({hide_upvoted: !settings.hide_upvoted})}/>
                        </SwitchItem>
                    </SwitchContainer>

                    <SwitchContainer>
                        <SwitchText>
                            <SwitchHeading>Show NSFW Content</SwitchHeading>
                            <SwitchDescription>
                                Images which are potentially unsafe will be blurred.
                            </SwitchDescription>
                        </SwitchText>
                        <SwitchItem>
                            <Switch isChecked={settings.show_nsfw}
                                    onChange={(value) => apply({show_nsfw: !settings.show_nsfw})}/>
                        </SwitchItem>
                    </SwitchContainer>

                    <SwitchContainer>
                        <SwitchText>
                            <SwitchHeading>Beta Features</SwitchHeading>
                            <SwitchDescription>
                                You might see features which are not released.
                            </SwitchDescription>
                        </SwitchText>
                        <SwitchItem>
                            <Switch isChecked={settings.beta}
                                    onChange={(value) => apply({beta: !settings.beta})}/>
                        </SwitchItem>
                    </SwitchContainer>

                </FormContainer>
            </WhiteMain>
        </>
    );
})`
  ${FormContainer} {
    background-color: ${({theme}) => theme.color.name === 'dark' ? 'transparent' : theme.white_0};
    padding: 16px 20px;
  }

  ${SwitchDescription} {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : 'rgb(89, 96, 104)'};
    font-size: 13px;
  }

  ${SwitchContainer} {
    width: 450px;
    max-width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 16px;
  }

  ${SwitchHeading} {
    font-weight: 600;
    font-size: 14px;
  }

  ${SwitchItem} {
    margin-left: auto;
  }
`;

export default GeneralSettings;
